export const MIN_USD_INVEST_AMOUNT_FIREBLOCKS =
  // yes that looks like a crutch but:
  // 1. such is life
  // 2. this is a slap-on-top feature for stagign only
  // 3. the juice here is not worth the squeeze
  import.meta.env.VITE_BASE_API?.startsWith('https://staging-api.zignaly.com')
    ? 1
    : 10;
